var _path, _g, _g2, _rect, _rect2, _line, _line2, _line3, _line4, _line5, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _path2, _path3, _path4, _line6, _line7, _line8, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _path5, _path6, _path7, _path8, _path9, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _g3, _line9, _line10, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _line11, _line12, _line13, _line14, _line15, _line16, _g11, _polygon, _path10, _path11, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _path12, _path13, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _path14, _path15, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _polygon25, _polygon26, _polygon27, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _g12, _path16, _path17, _path18, _path19, _rect94, _path20, _rect95, _rect96, _rect97, _circle, _path21, _circle2, _path22, _circle3, _path23, _path24;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFactory({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b499251b-ae79-475a-852c-fc2f01247840",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 865.76,
    height: 682.89,
    viewBox: "0 0 865.76 682.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "bd606623-ab99-4f09-bd4b-ba90bf38bf32",
    "data-name": "freesvgillustration--background-simple--inject-38"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M755.58,226.18C715.1,167.22,648,124.46,577.72,114.53l-1.57-.22c-103.65-13.93-203,96.6-233.74,113.15s-187.16,26.09-223.18,80S63,450.23,122.74,516.37,342.41,524.21,411,534.65c51.9,7.91,105.55,14.26,158.55,16.59,47,2.07,101.6,5.84,142.07-22.72,35.56-25.1,41.78-62.28,57-99.88,9.77-24.16,24.53-46.35,25.84-72.86C796.64,309.58,781.69,264.2,755.58,226.18Z",
    fill: "#f2eef1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M755.58,226.18C715.1,167.22,648,124.46,577.72,114.53l-1.57-.22c-103.65-13.93-203,96.6-233.74,113.15s-187.16,26.09-223.18,80S63,450.23,122.74,516.37,342.41,524.21,411,534.65c51.9,7.91,105.55,14.26,158.55,16.59,47,2.07,101.6,5.84,142.07-22.72,35.56-25.1,41.78-62.28,57-99.88,9.77-24.16,24.53-46.35,25.84-72.86C796.64,309.58,781.69,264.2,755.58,226.18Z",
    fill: "#fff",
    opacity: 0.7,
    style: {
      isolation: "isolate"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a4ecdadd-4dc7-4f72-b455-be7eabe233be",
    "data-name": "freesvgillustration--Clouds--inject-38"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M791.12,254.65H668.42l.86-.85c.69-.7,2.56-2.74,2.87-3.85.45-1.64,5.55-2.1,7.8-2.22a8.35,8.35,0,0,0,5.19-4.87c1.22-3.37,6.81-3.93,10.89-4.34a29.21,29.21,0,0,0,3.17-.42,7.91,7.91,0,0,0,3.13-1.54l.63.78a9.06,9.06,0,0,1-3.53,1.74,30.4,30.4,0,0,1-3.3.43c-3.82.38-9,.91-10.06,3.7a9.29,9.29,0,0,1-5.88,5.49l-.12,0c-3.54.19-6.79.89-7,1.49a10.83,10.83,0,0,1-2.32,3.44H790.57c.63-1.16,3-6.34-2.65-11.36-2.68-2.37-6.54-1.81-10-1.31-3.73.55-7.25,1.06-8-2.67l1-.2c.56,2.67,2.87,2.47,6.91,1.88,3.63-.53,7.74-1.13,10.76,1.56,6.91,6.14,2.74,12.81,2.69,12.87Z",
    fill: "#c69dd7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.24,233.68l-.83-.56a28.21,28.21,0,0,0,2.7-5.13,8.22,8.22,0,0,1,5-4.91c3.7-1.28,8.74-.28,14.2,2.81,3.37,1.9,5.71,2.52,7.37,1.94,2-.69,2.93-3.1,4.15-6.14a14.33,14.33,0,0,1,7.83-7.53,16.19,16.19,0,0,1,12.83.25c5.92,2.5,8.86,9.12,10.28,14.23l-1,.27c-1.37-4.9-4.16-11.23-9.71-13.58a15.27,15.27,0,0,0-12.06-.25,13.48,13.48,0,0,0-7.28,7c-1.27,3.15-2.36,5.87-4.75,6.71-1.95.69-4.55,0-8.19-2-5.21-2.95-10-3.92-13.38-2.74a7.31,7.31,0,0,0-4.45,4.34A29,29,0,0,1,706.24,233.68Z",
    fill: "#c69dd7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.79,215.08H324.17v-1h31a3.75,3.75,0,0,0-1.16-4.61c-1.15-1-2.75-.78-4.3-.55-1.36.2-2.63.38-3.4-.39-.55-.54-.71-1.44-.51-2.81-.08-.65-.88-6.75-4.69-8.37a6.53,6.53,0,0,0-6.45.58l-.57-.82a7.5,7.5,0,0,1,7.42-.67c4.55,1.92,5.26,8.95,5.29,9.24v.13c-.16,1-.08,1.71.22,2s1.44.27,2.54.11c1.61-.24,3.62-.53,5.07.77a4.73,4.73,0,0,1,1.28,6.13Z",
    fill: "#c69dd7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.26,215.08H299.69l.9-.86a6,6,0,0,0,1.22-1.66c.23-.63,1.47-1,3.7-1.14a3.5,3.5,0,0,0,2.14-2c.61-1.67,3.23-1.94,5.14-2.13a13.45,13.45,0,0,0,1.39-.18c1.43-.31,2.79-1.86,3.82-4.37a4,4,0,0,1,2.44-2.37c1.73-.6,4.08-.14,6.61,1.29,1.43.8,2.44,1.09,3.1.86s1.17-1.31,1.7-2.61l.93.37c-.6,1.48-1.11,2.76-2.3,3.18-1,.33-2.2,0-3.92-.93-2.28-1.29-4.33-1.72-5.79-1.21a3,3,0,0,0-1.85,1.8c-1.48,3.61-3.28,4.7-4.53,5a13.47,13.47,0,0,1-1.5.2c-1.56.15-3.91.39-4.31,1.48a4.46,4.46,0,0,1-2.83,2.65l-.12,0a7.7,7.7,0,0,0-2.91.55,6.69,6.69,0,0,1-.68,1.12h17.22Z",
    fill: "#c69dd7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.93,207.43H199.5v-1h86.88c.75-1.33,3.95-8-3.3-14.45-3.41-3-8.29-2.31-12.59-1.68-3.68.54-6.87,1-8.69-.82-1.32-1.32-1.69-3.59-1.17-7.16-.13-1.17-2.29-19.34-13.62-24.13a18.91,18.91,0,0,0-18.76,1.68l-.58-.82a19.88,19.88,0,0,1,19.73-1.78c12.2,5.16,14.15,24.21,14.23,25v.12c-.48,3.22-.19,5.3.88,6.37,1.46,1.47,4.42,1,7.84.54,4.52-.66,9.64-1.41,13.39,1.93,8.59,7.62,3.4,15.88,3.34,16Z",
    fill: "#c69dd7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.85,207.43H133.64l.86-.85c.88-.88,3.24-3.46,3.59-4.87.5-2,7.44-2.58,9.67-2.69a10.6,10.6,0,0,0,6.63-6.19c1.5-4.15,8.45-4.85,13.52-5.35,1.62-.17,3-.31,4-.53,4.32-1,8.32-5.47,11.26-12.7a10.15,10.15,0,0,1,6.2-6.06c4.6-1.6,10.89-.36,17.72,3.5,4.29,2.42,7.26,3.2,9.36,2.46,2.51-.89,3.72-3.93,5.25-7.78l.93.37c-1.56,3.92-2.91,7.31-5.85,8.35-2.39.84-5.63,0-10.18-2.53-6.58-3.72-12.58-4.93-16.9-3.42a9.11,9.11,0,0,0-5.6,5.49c-3.07,7.54-7.32,12.27-12,13.3a41.42,41.42,0,0,1-4.12.54c-4.81.48-11.4,1.14-12.69,4.71A11.59,11.59,0,0,1,148,200l-.12,0c-4.08.21-8.6,1-8.82,1.94-.34,1.38-2,3.36-3,4.48h49.83Z",
    fill: "#c69dd7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701,233.56H685.94v-1h14.51a3.77,3.77,0,0,0-1.2-4.63c-1.11-1-2.71-.75-4.27-.53-1.35.2-2.62.39-3.39-.38-.55-.55-.71-1.44-.51-2.81-.08-.66-.89-6.75-4.69-8.38a6.28,6.28,0,0,0-8.36,2.93c-.57,1.45-1.08,2.73-2.28,3.15-1,.34-2.2,0-3.92-.93-2.28-1.29-4.33-1.72-5.79-1.21a3,3,0,0,0-1.85,1.8c-1.48,3.61-3.28,4.7-4.53,5a13.47,13.47,0,0,1-1.5.2c-1.56.15-3.91.39-4.31,1.48a4.49,4.49,0,0,1-2.83,2.64l-.12,0a7.7,7.7,0,0,0-2.91.55,6.69,6.69,0,0,1-.68,1.12h33.76v1H645l.91-.86a5.89,5.89,0,0,0,1.22-1.66c.23-.63,1.47-1,3.7-1.14a3.51,3.51,0,0,0,2.14-2c.61-1.67,3.23-1.94,5.14-2.13a11.15,11.15,0,0,0,1.39-.18c1.43-.31,2.79-1.86,3.82-4.37a4,4,0,0,1,2.44-2.37c1.74-.6,4.08-.14,6.61,1.29,1.43.81,2.45,1.09,3.1.86s1.18-1.31,1.7-2.61a7.27,7.27,0,0,1,9.68-3.44c4.53,1.94,5.25,9,5.28,9.25v.13c-.16,1-.09,1.71.22,2s1.45.27,2.54.11c1.61-.24,3.62-.53,5.07.77a4.74,4.74,0,0,1,1.26,6.14Z",
    fill: "#c69dd7"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "fd294024-4584-4738-b186-30fc6b418596",
    "data-name": "freesvgillustration--factories-2--inject-38"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.13
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 356.7,
    cy: 249.85,
    rx: 9.13,
    ry: 6.96
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.88,246.8c-3.24,0-5.87-1.85-5.87-4.13s2.63-4.13,5.87-4.13,5.87,1.85,5.87,4.13S377.12,246.8,373.88,246.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.28,247.67c-2.29,0-4.14-.78-4.14-1.74s1.85-1.74,4.14-1.74,4.13.78,4.13,1.74S393.56,247.67,391.28,247.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505,282.3c-3.48,0-6.3-1.94-6.3-4.33s2.82-4.33,6.3-4.33,6.3,1.94,6.3,4.33S508.5,282.3,505,282.3Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 640.87,
    cy: 220.88,
    rx: 8.27,
    ry: 5.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.72,287.81c-2.61,0-4.73-1.41-4.73-3.15s2.12-3.15,4.73-3.15,4.72,1.41,4.72,3.15S490.33,287.81,487.72,287.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.57,283.88c-4.56,0-8.26-2.47-8.26-5.52s3.7-5.51,8.26-5.51,8.27,2.47,8.27,5.51S476.14,283.88,471.57,283.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.38,387.36V367H112.5V356.7h2.92V297h1.71c-1.73-3-3.43-9-.24-19,5.12-16.15,10.64-9.85,18.12-10.24s1.68-14.3,15.4-23.89,25.92,1.4,33,7.7,8.66,7.49,17.72-6.69,22.06-14.18,27.58-9.06,6.3,15,7.88,18.91,7.09,13,17.33,4.72a30.66,30.66,0,0,1,14.47-6.06c.48-.64,1-1.3,1.61-2,7.89-9.15,28.71-4.73,36.59,0s14.2,3.15,21.77-1.26,21.45-1.26,17.35,9.15-10.73,17-27.45,15.77-27.1-13.88-27.76-10.73c-.56,2.82,15.5,6.91,11.25,16.75,6.81-.14,14.58-.67,14,9.11-.79,13.79-19.7,15.36-29.15,11-5.15-2.36-10.3-10-14.74-15.27-1.87,1.84-3.89,4.9-7.24,4.56a14.91,14.91,0,0,1-6.4-2.53,46.43,46.43,0,0,1-3,3.57v5H253.7v41.16h50.9v6.82h-2.24v88.7h22.25V331.93H379.5l-.32,39.35h64V300.46h15v70.87h74.74l10.52-130H557.5l10.52,130h38.12l10.53-130H617a8.27,8.27,0,0,1-4.53-7c0-4.79,4.85-8.66,10.83-8.66a12.39,12.39,0,0,1,7.22,2.22,7.33,7.33,0,0,1,4.58-1.44c3.16,0,5.71,1.59,5.71,3.55s-2.55,3.54-5.71,3.54a8.39,8.39,0,0,1-1-.06,6.07,6.07,0,0,1,.06.85,8.27,8.27,0,0,1-4.53,7h1.11L651.87,502H99.13V387.36ZM151.5,279.15a27.25,27.25,0,0,1-2.22,5.63c6-3.93,12.2-4.11,16,.28a21.8,21.8,0,0,0,1.65,1.68C160.25,279,154.36,269,151.5,279.15Zm61.14,6.71c.83,3.38,1,5.65,6.61,3.93l.26-.09c-2.48-1.46-4.77-2.77-6.85-3.84ZM150.13,312.2v2.36h1.93v10.26h-1.93v59.76h22.25v-40h-2v-6.82h70.83V299a17.57,17.57,0,0,1-5-.61c-1.64,7.41-9.61,15.86-25.19,12-22.06-5.51-27.57-15.36-29.54-9.06s-8.28,10.24-14.58,6.7-9.85-15.37-13-12.61,1.18,5.52-6.3,5.12c-2.72-.14-3.72.6-4,1.53h8.53v10.25Zm-25-15.2v59.7h2.73V367h-2.75v19H139V324.82h-2.33V314.56H139V312.2h-2.33V302h3.45a4.77,4.77,0,0,1,0-1.92s-4.17-1.15,2.78-9.41c-3,.86-6.45-.07-9.87-2.41-5.56-3.8-10.46,4.34-12.62,8.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.24,291.75c0-4.78,4.84-8.66,10.82-8.66a12.39,12.39,0,0,1,7.22,2.22,7.28,7.28,0,0,1,4.59-1.43c3.15,0,5.7,1.58,5.7,3.54S469,291,465.87,291a8.39,8.39,0,0,1-1-.06,8.08,8.08,0,0,1,.05.85c0,4.78-4.84,8.66-10.82,8.66S443.24,296.53,443.24,291.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657,224c2.61,0,4.73,1.41,4.73,3.15s-2.12,3.15-4.73,3.15-4.72-1.41-4.72-3.15S654.4,224,657,224Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.34,216.16c3.48,0,6.3,1.94,6.3,4.33s-2.82,4.33-6.3,4.33-6.3-1.94-6.3-4.33S670.86,216.16,674.34,216.16Z"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M374.14,225.67c-1.09-11.63-2.46-27.32,5.61-37,10.14-12.21,35.75-5.88,50.13-6.85,1.45-.1,2.83-.2,4.17-.31h0c1.3-.17,2.62-.29,4-.37h0a129.88,129.88,0,0,0,13.66-2h.23l1.88-.4.4-.09,1.66-.41.45-.12,1.5-.42.44-.13c.48-.14,1-.29,1.4-.44l.4-.13,1.3-.46.37-.14c.42-.16.83-.32,1.22-.49l.31-.13c.4-.17.8-.34,1.18-.52l.22-.1c.4-.19.79-.38,1.17-.58l.11-.06c4.93-2.56,8.12-5.63,12.3-9.1h.06l1-.83.29-.23.89-.71.41-.32.86-.66.49-.37.88-.64.55-.39.93-.64.6-.41,1.1-.71c.17-.11.34-.23.53-.34.56-.36,1.14-.71,1.75-1.08,1.14-.67,2.31-1.3,3.49-1.91l1.15-.56c.82-.4,1.64-.78,2.47-1.15l1.36-.58c.81-.34,1.63-.65,2.45-1,.45-.16.88-.34,1.33-.49,1.16-.4,2.32-.77,3.5-1.1.58-.16,1.16-.3,1.74-.44s1.27-.33,1.9-.46,1.41-.29,2.12-.42l1.43-.25c.79-.12,1.57-.24,2.36-.33l.77-.07a48.27,48.27,0,0,1,8.75-.13h.16c1,.08,2,.2,2.94.35h0a30.72,30.72,0,0,1,10.73,3.67c13.34-5.13,28-5.87,38.07-.34,18.11-6.67,38.32-5.28,46.32,8.87,9.66,17.1,5.2,21.56,14.86,21.56s14.13-5.21,20.82-2.23,10.4,8.17,12.63,8.17,8.18-6.69,14.12-3,9.67,13.38,9.67,13.38,3,11.89-11.15,9.66c-6.61-1-9.54-6-15.1-8-6-2.13-9.43,1.48-13.38,5.21.85-.79,1.67-1.59,2.5-2.32-.49,2.21-2,4.48-5.71,5.13h0c-.53.41-1.07.81-1.64,1.17-7.93,5-18.47,2.86-26.9-1.25-1.8-.87-3.56-1.84-5.31-2.83h0a6,6,0,0,1-.92,1.1l-.13.12a6.29,6.29,0,0,1-1.28.9,23.73,23.73,0,0,1-2.62,1.95c-7.94,5-18.47,2.86-26.91-1.25-2.11-1-4.17-2.18-6.22-3.36h0l-.07.06-1.07,1-.36.34-.87.78-.45.38c-.29.25-.59.49-.89.73l-.43.34c-.33.25-.68.49-1,.72-.58.58-1.19,1.16-1.83,1.7-9.3,7.81-22.27,12-34.35,11.87a43.39,43.39,0,0,1-16.57-3.87h0a54.69,54.69,0,0,1-20.57,4,44,44,0,0,1-17.27-4.17q-2.31.94-4.73,1.69l-1.27.37c-1,.28-2,.54-3,.76-.78.18-1.55.34-2.33.48l-1.52.26c-1.2.18-2.4.33-3.6.43l-.92.06c-1.35.09-2.69.14-4,.12-.71,0-1.42,0-2.11-.1-1.15,13.69-1.57,27.89-1.57,27.89h-8.39s2.44-2.22.21-26c-.12-1.28-.24-2.61-.35-4l-1-.35-.71-.26c-.88-.32-1.74-.67-2.6-1l-.3-.13c-1-.44-2-.9-3.05-1.39h-.1c-1-.49-2-1-3-1.52h-.05c-4.87-2.54-9.64-5.41-14.51-8h0c-.11.58-.22,1.18-.31,1.83-2.23,15.61-3,40.87-3,40.87h-8.39s2.44-2.22.21-26c-.62-6.55-1.32-14.4-.37-21.73-.62-.19-1.23-.4-1.86-.57-14.12-3.71-23-8.17-25.27,7.44s-3,40.87-3,40.87H374S376.37,249.46,374.14,225.67Z",
    opacity: 0.15,
    style: {
      isolation: "isolate"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 619.72,
    y: 289.93,
    width: 107.36,
    height: 211.99,
    fill: "#c69dd7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 619.72,
    y: 289.93,
    width: 107.36,
    height: 211.99,
    opacity: 0.2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 650.52,
    y1: 312.6,
    x2: 620.26,
    y2: 312.6,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 650.52,
    y1: 348.63,
    x2: 620.26,
    y2: 348.63,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 650.52,
    y1: 386.05,
    x2: 620.26,
    y2: 386.05,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 650.52,
    y1: 424.87,
    x2: 620.26,
    y2: 424.87,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 650.52,
    y1: 460.9,
    x2: 620.26,
    y2: 460.9,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 650.43,
    y: 289.93,
    width: 76.65,
    height: 211.99,
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 650.43,
    y: 289.93,
    width: 76.65,
    height: 11.92,
    fill: "#c69dd7"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 650.43,
    y: 289.93,
    width: 76.65,
    height: 11.92,
    opacity: 0.2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 650.43,
    y: 327.04,
    width: 76.65,
    height: 11.92,
    fill: "#c69dd7"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 650.43,
    y: 327.04,
    width: 76.65,
    height: 11.92,
    opacity: 0.2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 650.43,
    y: 365.07,
    width: 76.65,
    height: 11.92,
    fill: "#c69dd7"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 650.43,
    y: 365.07,
    width: 76.65,
    height: 11.92,
    opacity: 0.2
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 650.43,
    y: 402.18,
    width: 76.65,
    height: 11.92,
    fill: "#c69dd7"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 650.43,
    y: 402.18,
    width: 76.65,
    height: 11.92,
    opacity: 0.3
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 650.43,
    y: 478.11,
    width: 76.65,
    height: 10.2,
    fill: "#c69dd7"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 650.43,
    y: 478.11,
    width: 76.65,
    height: 10.2,
    opacity: 0.3
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 650.43,
    y: 439.28,
    width: 76.65,
    height: 11.92,
    fill: "#c69dd7"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 650.43,
    y: 439.28,
    width: 76.65,
    height: 11.92,
    opacity: 0.3
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 671.64,
    y: 481.07,
    width: 30.64,
    height: 20.85,
    fill: "#c69dd7"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 671.64,
    y: 481.07,
    width: 30.64,
    height: 20.85,
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M664.57,480.39a.5.5,0,0,1-.5-.5V296.44a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5V479.89A.5.5,0,0,1,664.57,480.39Z",
    fill: "#c69dd7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M688.14,480.39a.5.5,0,0,1-.5-.5V296.44a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5V479.89A.5.5,0,0,1,688.14,480.39Z",
    fill: "#c69dd7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M711.71,480.39a.5.5,0,0,1-.5-.5V296.44a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5V479.89A.5.5,0,0,1,711.71,480.39Z",
    fill: "#c69dd7"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 628.04,
    y1: 296.44,
    x2: 628.04,
    y2: 479.89,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 635.5,
    y1: 296.44,
    x2: 635.5,
    y2: 479.89,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 642.97,
    y1: 296.44,
    x2: 642.97,
    y2: 479.89,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 615.61,
    y: 287.49,
    width: 114.96,
    height: 10.13,
    fill: "#c69dd7"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 615.61,
    y: 287.49,
    width: 114.96,
    height: 10.13,
    opacity: 0.2
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 646.89,
    y: 287.49,
    width: 83.67,
    height: 10.13,
    fill: "#c69dd7"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 615.61,
    y: 325.2,
    width: 114.96,
    height: 10.13,
    fill: "#c69dd7"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 615.61,
    y: 325.2,
    width: 114.96,
    height: 10.13,
    opacity: 0.3
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 646.89,
    y: 325.2,
    width: 83.67,
    height: 10.13,
    fill: "#c69dd7"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 615.61,
    y: 362.91,
    width: 114.96,
    height: 10.13,
    fill: "#c69dd7"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 615.61,
    y: 362.91,
    width: 114.96,
    height: 10.13,
    opacity: 0.3
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 646.89,
    y: 362.91,
    width: 83.67,
    height: 10.13,
    fill: "#c69dd7"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 615.61,
    y: 400.63,
    width: 114.96,
    height: 10.13,
    fill: "#c69dd7"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 615.61,
    y: 400.63,
    width: 114.96,
    height: 10.13,
    opacity: 0.3
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 646.89,
    y: 400.63,
    width: 83.67,
    height: 10.13,
    fill: "#c69dd7"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 615.61,
    y: 438.34,
    width: 114.96,
    height: 10.13,
    fill: "#c69dd7"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 615.61,
    y: 438.34,
    width: 114.96,
    height: 10.13,
    opacity: 0.3
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 646.89,
    y: 438.34,
    width: 83.67,
    height: 10.13,
    fill: "#c69dd7"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 615.61,
    y: 476.05,
    width: 114.96,
    height: 10.13,
    fill: "#c69dd7"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 615.61,
    y: 476.05,
    width: 114.96,
    height: 10.13,
    opacity: 0.3
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 646.89,
    y: 476.05,
    width: 83.67,
    height: 10.13,
    fill: "#c69dd7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M726.43,313.1H650.52a.5.5,0,0,1,0-1h75.91a.5.5,0,0,1,0,1Z",
    fill: "#c69dd7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M726.43,349.13H650.52a.5.5,0,0,1,0-1h75.91a.5.5,0,0,1,0,1Z",
    fill: "#c69dd7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M726.43,386.55H650.52a.5.5,0,0,1,0-1h75.91a.5.5,0,0,1,0,1Z",
    fill: "#c69dd7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M726.43,425.37H650.52a.5.5,0,0,1,0-1h75.91a.5.5,0,0,1,0,1Z",
    fill: "#c69dd7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M726.43,461.4H650.52a.5.5,0,0,1-.5-.5.51.51,0,0,1,.5-.5h75.91a.5.5,0,0,1,.5.5A.5.5,0,0,1,726.43,461.4Z",
    fill: "#c69dd7"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 650.73,
    y: 496.48,
    width: 71.06,
    height: 2.5,
    fill: "#c69dd7"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 650.73,
    y: 498.98,
    width: 92.03,
    height: 3.76,
    fill: "#c69dd7"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 650.73,
    y: 498.98,
    width: 92.03,
    height: 3.76,
    opacity: 0.3
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 485.92,
    y: 249.7,
    width: 136.77,
    height: 252.18,
    fill: "#c69dd7"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 485.92,
    y: 249.7,
    width: 136.77,
    height: 252.18,
    opacity: 0.2
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 522.06,
    y: 249.7,
    width: 100.63,
    height: 252.18,
    fill: "#c69dd7"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 545.92,
    y: 477.78,
    width: 76.76,
    height: 24.1,
    fill: "#c69dd7"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 545.92,
    y: 477.78,
    width: 76.76,
    height: 24.1,
    opacity: 0.2
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 563.68,
    y: 477.78,
    width: 4.18,
    height: 24.1,
    fill: "#fff"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 585.23,
    y: 477.78,
    width: 4.18,
    height: 24.1,
    fill: "#fff"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 606.79,
    y: 477.78,
    width: 4.18,
    height: 24.1,
    fill: "#fff"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M560.37,478.28a.5.5,0,0,1-.5-.5V250.28a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5v227.5A.5.5,0,0,1,560.37,478.28Z"
  }))), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 509.02,
    y1: 502.74,
    x2: 509.02,
    y2: 250.28,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 496.57,
    y1: 502.74,
    x2: 496.57,
    y2: 250.28,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M598.58,478.28a.5.5,0,0,1-.5-.5V250.28a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5v227.5A.5.5,0,0,1,598.58,478.28Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M622.1,276.65H522.58a.5.5,0,0,1,0-1H622.1a.5.5,0,0,1,0,1Z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M622.1,310.16H522.58a.5.5,0,0,1,0-1H622.1a.5.5,0,0,1,0,1Z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M622.1,343.66H522.58a.5.5,0,0,1,0-1H622.1a.5.5,0,0,1,0,1Z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M622.1,377.17H522.58a.5.5,0,0,1,0-1H622.1a.5.5,0,0,1,0,1Z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M622.1,410.68H522.58a.5.5,0,0,1,0-1H622.1a.5.5,0,0,1,0,1Z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M622.1,444.18H522.58a.5.5,0,0,1,0-1H622.1a.5.5,0,0,1,0,1Z"
  }))), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 522.58,
    y1: 276.15,
    x2: 485.75,
    y2: 276.15,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 522.58,
    y1: 309.66,
    x2: 485.75,
    y2: 309.66,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 522.58,
    y1: 343.16,
    x2: 485.75,
    y2: 343.16,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 522.58,
    y1: 376.67,
    x2: 485.75,
    y2: 376.67,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 522.58,
    y1: 410.18,
    x2: 485.75,
    y2: 410.18,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 522.58,
    y1: 443.68,
    x2: 485.75,
    y2: 443.68,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M622.1,477.69H486.3a.5.5,0,0,1-.5-.5.51.51,0,0,1,.5-.5H622.1a.5.5,0,0,1,.5.5A.5.5,0,0,1,622.1,477.69Z"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "386.63 250.16 372.67 250.16 365.69 423.96 393.61 423.96 386.63 250.16",
    fill: "#c69dd7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M386.5,251.69H372.76a1.5,1.5,0,0,1-1.5-1.5h0a1.5,1.5,0,0,1,1.5-1.5H386.5a1.5,1.5,0,0,1,1.5,1.5h0A1.5,1.5,0,0,1,386.5,251.69Z",
    fill: "#c69dd7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M386.5,251.69H372.76a1.5,1.5,0,0,1-1.5-1.5h0a1.5,1.5,0,0,1,1.5-1.5H386.5a1.5,1.5,0,0,1,1.5,1.5h0A1.5,1.5,0,0,1,386.5,251.69Z",
    opacity: 0.2
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "372.35 258.14 372.09 264.41 387.2 264.41 386.95 258.14 372.35 258.14",
    fill: "#f2eef1"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "392.65 400.03 392.39 393.76 366.9 393.76 366.65 400.03 392.65 400.03",
    fill: "#f2eef1"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "368.45 355.01 368.2 361.28 391.09 361.28 390.84 355.01 368.45 355.01",
    fill: "#f2eef1"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "367.68 374.39 367.43 380.66 391.87 380.66 391.62 374.39 367.68 374.39",
    fill: "#f2eef1"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "369.23 335.64 368.98 341.91 390.31 341.91 390.06 335.64 369.23 335.64",
    fill: "#f2eef1"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "371.57 277.52 371.31 283.78 387.98 283.78 387.73 277.52 371.57 277.52",
    fill: "#f2eef1"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "370.01 316.27 369.76 322.53 389.53 322.53 389.28 316.27 370.01 316.27",
    fill: "#f2eef1"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "370.79 296.89 370.54 303.16 388.75 303.16 388.5 296.89 370.79 296.89",
    fill: "#f2eef1"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "424.24 250.16 410.27 250.16 403.3 423.96 431.22 423.96 424.24 250.16",
    fill: "#c69dd7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M424.15,251.69H410.36a1.5,1.5,0,0,1-1.49-1.5h0a1.51,1.51,0,0,1,1.49-1.5h13.79a1.5,1.5,0,0,1,1.5,1.5h0A1.5,1.5,0,0,1,424.15,251.69Z",
    fill: "#c69dd7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M424.15,251.69H410.36a1.5,1.5,0,0,1-1.49-1.5h0a1.51,1.51,0,0,1,1.49-1.5h13.79a1.5,1.5,0,0,1,1.5,1.5h0A1.5,1.5,0,0,1,424.15,251.69Z",
    opacity: 0.2
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "409.95 258.14 409.7 264.41 424.81 264.41 424.56 258.14 409.95 258.14",
    fill: "#f2eef1"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "430.26 400.03 430 393.76 404.51 393.76 404.26 400.03 430.26 400.03",
    fill: "#f2eef1"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "406.06 355.01 405.81 361.28 428.7 361.28 428.45 355.01 406.06 355.01",
    fill: "#f2eef1"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "405.29 374.39 405.03 380.66 429.48 380.66 429.23 374.39 405.29 374.39",
    fill: "#f2eef1"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "406.84 335.64 406.59 341.91 427.92 341.91 427.67 335.64 406.84 335.64",
    fill: "#f2eef1"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    points: "409.18 277.52 408.93 283.78 425.59 283.78 425.33 277.52 409.18 277.52",
    fill: "#f2eef1"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    points: "407.62 316.27 407.37 322.53 427.14 322.53 426.89 316.27 407.62 316.27",
    fill: "#f2eef1"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    points: "408.4 296.89 408.15 303.16 426.37 303.16 426.11 296.89 408.4 296.89",
    fill: "#f2eef1"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    points: "461.85 250.16 447.88 250.16 440.9 423.96 468.83 423.96 461.85 250.16",
    fill: "#c69dd7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M461.76,251.69H448a1.5,1.5,0,0,1-1.49-1.5h0a1.51,1.51,0,0,1,1.49-1.5h13.79a1.5,1.5,0,0,1,1.49,1.5h0A1.49,1.49,0,0,1,461.76,251.69Z",
    fill: "#c69dd7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M461.76,251.69H448a1.5,1.5,0,0,1-1.49-1.5h0a1.51,1.51,0,0,1,1.49-1.5h13.79a1.5,1.5,0,0,1,1.49,1.5h0A1.49,1.49,0,0,1,461.76,251.69Z",
    opacity: 0.2
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    points: "447.56 258.14 447.31 264.41 462.42 264.41 462.17 258.14 447.56 258.14",
    fill: "#f2eef1"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    points: "467.87 400.03 467.61 393.76 442.12 393.76 441.87 400.03 467.87 400.03",
    fill: "#f2eef1"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    points: "443.67 355.01 443.42 361.28 466.31 361.28 466.06 355.01 443.67 355.01",
    fill: "#f2eef1"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    points: "442.89 374.39 442.64 380.66 467.09 380.66 466.83 374.39 442.89 374.39",
    fill: "#f2eef1"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    points: "444.45 335.64 444.2 341.91 465.53 341.91 465.28 335.64 444.45 335.64",
    fill: "#f2eef1"
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    points: "446.79 277.52 446.53 283.78 463.2 283.78 462.94 277.52 446.79 277.52",
    fill: "#f2eef1"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    points: "445.23 316.27 444.98 322.53 464.75 322.53 464.5 316.27 445.23 316.27",
    fill: "#f2eef1"
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    points: "446.01 296.89 445.76 303.16 463.97 303.16 463.72 296.89 446.01 296.89",
    fill: "#f2eef1"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 286.9,
    y: 402.63,
    width: 179.63,
    height: 100.11,
    fill: "#c69dd7"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 365.95,
    y: 402.63,
    width: 190.17,
    height: 100.11,
    fill: "#fff"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 390.28,
    y: 440.99,
    width: 31.34,
    height: 61.75,
    fill: "#c69dd7"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 390.28,
    y: 440.99,
    width: 31.34,
    height: 61.75,
    opacity: 0.2
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 390.28,
    y: 440.99,
    width: 26.2,
    height: 61.75,
    fill: "#c69dd7"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 446.41,
    y: 440.99,
    width: 31.34,
    height: 61.75,
    fill: "#c69dd7"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 446.41,
    y: 440.99,
    width: 31.34,
    height: 61.75,
    opacity: 0.2
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 446.41,
    y: 440.99,
    width: 26.2,
    height: 61.75,
    fill: "#c69dd7"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 502.55,
    y: 440.99,
    width: 31.34,
    height: 61.75,
    fill: "#c69dd7"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 502.55,
    y: 440.99,
    width: 31.34,
    height: 61.75,
    opacity: 0.2
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 502.55,
    y: 440.99,
    width: 26.2,
    height: 61.75,
    fill: "#c69dd7"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 294.11,
    y: 414.09,
    width: 17.1,
    height: 15.68,
    opacity: 0.2
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 317.22,
    y: 414.09,
    width: 17.1,
    height: 15.68,
    opacity: 0.2
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 340.33,
    y: 414.09,
    width: 17.1,
    height: 15.68,
    opacity: 0.2
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 392.8,
    y: 414.09,
    width: 25.54,
    height: 15.68,
    fill: "#c69dd7"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 392.8,
    y: 414.09,
    width: 25.54,
    height: 15.68,
    opacity: 0.2
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 391.35,
    y: 414.09,
    width: 25.54,
    height: 15.68,
    fill: "#c69dd7"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 448.88,
    y: 414.09,
    width: 25.54,
    height: 15.68,
    fill: "#c69dd7"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 448.88,
    y: 414.09,
    width: 25.54,
    height: 15.68,
    opacity: 0.2
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 447.43,
    y: 414.09,
    width: 25.54,
    height: 15.68,
    fill: "#c69dd7"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 504.97,
    y: 414.09,
    width: 25.54,
    height: 15.68,
    fill: "#c69dd7"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 504.97,
    y: 414.09,
    width: 25.54,
    height: 15.68,
    opacity: 0.2
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 503.51,
    y: 414.09,
    width: 25.54,
    height: 15.68,
    fill: "#c69dd7"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 261.65,
    y: 429.6,
    width: 22.75,
    height: 13.17,
    fill: "#c69dd7"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 268.82,
    y: 429.6,
    width: 22.75,
    height: 13.17,
    fill: "#c69dd7"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 268.82,
    y: 429.6,
    width: 22.75,
    height: 13.17,
    fill: "#fff",
    opacity: 0.2
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 256.12,
    y: 437,
    width: 56.08,
    height: 65.73,
    fill: "#c69dd7"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 256.12,
    y: 437,
    width: 56.08,
    height: 65.73,
    opacity: 0.2
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 297.73,
    y: 437,
    width: 56.08,
    height: 65.73,
    fill: "#fff"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 318.23,
    y: 478.62,
    width: 15.08,
    height: 24.12,
    fill: "#c69dd7"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 282.97,
    y: 444.84,
    width: 9.33,
    height: 44.63,
    fill: "#fff"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 271.05,
    y: 444.84,
    width: 9.33,
    height: 44.63,
    fill: "#fff"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 259.13,
    y: 444.84,
    width: 9.33,
    height: 44.63,
    fill: "#fff"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 372.21,
    y: 412.85,
    width: 13.42,
    height: 89.48,
    fill: "#c69dd7"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 372.21,
    y: 412.85,
    width: 13.42,
    height: 89.48,
    opacity: 0.2
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 374.32,
    y: 412.85,
    width: 13.42,
    height: 89.48,
    fill: "#c69dd7"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 426.96,
    y: 412.85,
    width: 13.42,
    height: 89.48,
    fill: "#c69dd7"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 426.96,
    y: 412.85,
    width: 13.42,
    height: 89.48,
    opacity: 0.2
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 429.06,
    y: 412.85,
    width: 13.42,
    height: 89.48,
    fill: "#c69dd7"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 483.01,
    y: 412.85,
    width: 13.42,
    height: 89.48,
    fill: "#c69dd7"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 483.01,
    y: 412.85,
    width: 13.42,
    height: 89.48,
    opacity: 0.2
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 485.12,
    y: 412.85,
    width: 13.42,
    height: 89.48,
    fill: "#c69dd7"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 539.14,
    y: 412.85,
    width: 13.42,
    height: 89.48,
    fill: "#c69dd7"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 539.14,
    y: 412.85,
    width: 13.42,
    height: 89.48,
    opacity: 0.2
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 541.25,
    y: 412.85,
    width: 13.42,
    height: 89.48,
    fill: "#c69dd7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M791.88,337.1l10.89-.31-84.4-7.27s-20.35-16-43.61-17.44-24.71,17.44-33.43,14.53-10.17-14.53-32-13.08-27.59,14.53-42.13,11.63-24.7-33.43-68.31-34.89-97.39,39.25-97.39,39.25a90.5,90.5,0,0,1-13.21,7.58Z",
    fill: "#fff",
    opacity: 0.7,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.74,372.83l9.38-.27L402.21,366.3s-17.52-13.77-37.55-15-21.28,15-28.79,12.52-8.76-12.52-27.54-11.27-23.78,12.52-36.3,10-21.27-28.79-58.83-30-83.86,33.79-83.86,33.79A76.86,76.86,0,0,1,118,372.87Z",
    fill: "#fff",
    opacity: 0.7,
    style: {
      isolation: "isolate"
    }
  }), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 99.13,
    y: 502.02,
    width: 659.21,
    height: 27.86,
    fill: "#c69dd7"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 99.13,
    y: 502.02,
    width: 659.21,
    height: 27.86,
    opacity: 0.4
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.21
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.6,500.92a7.09,7.09,0,1,1-7.13-7.05h0A7.08,7.08,0,0,1,136.6,500.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.42,496a6.23,6.23,0,1,1-6.23-6.23h0a6.22,6.22,0,0,1,6.22,6.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.85,498.87a1.76,1.76,0,1,1-1.73-1.79h0A1.77,1.77,0,0,1,101.85,498.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.72,487.47a3.66,3.66,0,1,1-3.72-3.6h.07A3.65,3.65,0,0,1,106.72,487.47Z"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M134.82,498.47h81.37v-3.25h13l8,4.71.23,7.34h-17.9v-4.71H189.13a15.24,15.24,0,0,1,.77,5.4h-1.39s-.31-4.17-1.15-5.33H182v8.57H155.13v-8.26h-4.51A9.51,9.51,0,0,0,149.4,508h-1.49a10.26,10.26,0,0,1,1-5.06H136.6Z",
    fill: "#c69dd7"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M134.82,498.47h81.37v-3.25h13l8,4.71.23,7.34h-17.9v-4.71H189.13a15.24,15.24,0,0,1,.77,5.4h-1.39s-.31-4.17-1.15-5.33H182v8.57H155.13v-8.26h-4.51A9.51,9.51,0,0,0,149.4,508h-1.49a10.26,10.26,0,0,1,1-5.06H136.6Z",
    opacity: 0.3
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M219.67,477.11a4.26,4.26,0,0,1,.71-2.13,5.3,5.3,0,0,1,3-1.28c.52-.07,13.58.13,15.52.83s2.31,1.42,2.31,1.74,3.8,9.79,3.8,9.79a10.47,10.47,0,0,1,1.12,2.51c.26,1.09-.06,10.23-.39,10.43a4.16,4.16,0,0,1-1.35.19l.13,1.29s2,0,2.06.38,0,7.92,0,7.92H236.13v-6.43a7.84,7.84,0,0,0-6.57-5.41c-5.47-.9-7.66-.26-7.66-.26h-2.64v-18Z",
    fill: "#f2eef1"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M241.79,485.79H228.11V478.2l.62-.44h10Zm-13.18-.5h12.45l-2.7-7h-9.47l-.28.2Z",
    fill: "#c69dd7"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 227.15,
    y: 477.56,
    width: 0.5,
    height: 16.09,
    fill: "#c69dd7"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M236.5,499.45c-.05-.05-5.13-4.55-7.44-5.17s-7.51,0-7.56,0l-.06-.5c.21,0,5.34-.64,7.75,0s7.43,5.08,7.64,5.27Z",
    fill: "#c69dd7"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 131.74,
    y: 464.43,
    width: 87.45,
    height: 35.71,
    fill: "#c69dd7"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 131.74,
    y: 497.23,
    width: 87.45,
    height: 2.91,
    fill: "#f2eef1"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 191.67,
    y: 500.59,
    width: 21.72,
    height: 8.53,
    fill: "#c69dd7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 226.83,
    cy: 508.67,
    r: 7.45,
    transform: "translate(-320.35 612.59) rotate(-76.72)",
    fill: "#c69dd7"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M222.81,508.7a4,4,0,1,1,4,4A4,4,0,0,1,222.81,508.7Z",
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 179.88,
    cy: 508.72,
    r: 7.45,
    transform: "translate(-357.7 555.21) rotate(-75.47)",
    fill: "#c69dd7"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M175.85,508.7a4,4,0,1,1,4,4A4,4,0,0,1,175.85,508.7Z",
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 158.93,
    cy: 508.7,
    r: 7.45,
    transform: "translate(-313.16 261.38) rotate(-45)",
    fill: "#c69dd7"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M154.9,508.7a4,4,0,1,1,4,4A4,4,0,0,1,154.9,508.7Z",
    fill: "#fff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M243.14,508.35a.25.25,0,0,1-.25-.25v-7a.25.25,0,0,1,.25-.25.25.25,0,0,1,.25.25v7A.25.25,0,0,1,243.14,508.35Z",
    fill: "#c69dd7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFactory);
export default __webpack_public_path__ + "static/media/Factory.b076808ddc917fa3876b738eec470aa4.svg";
export { ForwardRef as ReactComponent };